import { useSelector } from 'react-redux';

import { ProviderClinicalStatus } from '../admin/constants/general';
import { Roles } from '../constants';
import { areUserRolesIn } from '../helpers';

import type { RootState } from '../store';

export default function usePreClinicalGuardianGating() {
  const { user } = useSelector((state: RootState) => state.auth);
  const { provider, loading, error } = useSelector((state: RootState) => state.providers);

  const isGuardian = areUserRolesIn(user?.roles, [Roles.Guardian]);
  const clinicalStatus = provider?.clinical_status;
  // An invited guardian is still onboarding: they log in with GUARDIAN INVITED (never
  // CLINICAL) to complete their questionnaires, so they get the pre-clinical experience.
  const isOnboardingGuardian =
    clinicalStatus === ProviderClinicalStatus.PRE_CLINICAL ||
    clinicalStatus === ProviderClinicalStatus.GUARDIAN_INVITED;

  const hideClinicalFeatures = isGuardian && (!clinicalStatus || isOnboardingGuardian);
  const showPreClinicalFeatures = isGuardian && isOnboardingGuardian;
  // Pending while the Header provider fetch is in flight (or has not started). Once it
  // settles without clinical_status, PrivateRoute uses the existing redirect path.
  const isClinicalGatingPending =
    isGuardian && !clinicalStatus && (loading || (provider === null && error === null));

  return { hideClinicalFeatures, showPreClinicalFeatures, isClinicalGatingPending };
}
